import { render, staticRenderFns } from "./PublicReservation4.vue?vue&type=template&id=0dad5f62&scoped=true&"
import script from "./PublicReservation4.vue?vue&type=script&lang=js&"
export * from "./PublicReservation4.vue?vue&type=script&lang=js&"
import style0 from "./PublicReservation4.vue?vue&type=style&index=0&id=0dad5f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad5f62",
  null
  
)

export default component.exports